import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;

  button {
    margin-top: 21px;
    margin-bottom: 27px;
    width: 318px;
  }
`;
